module.exports = new __parcel__URL__("favicon-temp-family.656d6159.png").toString();